<template>
  <validated-input
    :id="'digital-key-' + _uid"
    :value="value"
    idGtm="claveDigital"
    :validations="validations"
    :label="label"
    @input="onInput"
    :quantumObfuscate="quantumObfuscate"
  />
</template>

<script>
import ValidatedInput from "./ValidatedInput.vue";
export default {
  name: "DigitalKey",
  components: {
    ValidatedInput
  },
  props: {
    value: String,
    required: {
      type: Boolean,
      default: false
    },
    label: String,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      validations: {
        length: {
          message: "Debe tener al menos 8 dígitos.",
          validate: value => value.length >= 8
        },
        atLeastOneLetter: {
          message: "Al menos una letra.",
          validate: value => /[a-zA-Z]/.test(value)
        },
        noSpecialChars: {
          message: "No se permiten caracteres especiales.",
          validate: value => /^[a-zA-Z0-9]*$/.test(value)
        },
        atLeastOneNumber: {
          message: "Al menos un número.",
          validate: value => /\d/.test(value)
        }
      }
    };
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    this.subscribe(this);
  }
};
</script>
